import { Component, input } from '@angular/core';

@Component({
  selector: 'shared-ui-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.css'],
})
export class BadgeComponent {
  text = input<string | number | undefined>();

  width = input<number | undefined>();

  height = input<number | undefined>();
}
